<template>
	<section class="small-12 columns widget propertyTaxes" v-if="property">
		<div class="small-12 widgetTitle flex vertical-align">
			<h2 class="small-12 flex vertical-align"> 
				Property Taxes
			</h2>
		</div>
		<ul class="small-12 flex" v-if="future_item">
			<li class="small-12 large-4">
				<p class="small-12 flex vertical-align">
					Parcel Number
				</p>
				<span class="small-12 flex vertical-align">
					21-1361-3
				</span>
			</li>
			<li class="small-12 large-4">
				<p class="small-12 flex vertical-align">
					Zoning Code
				</p>
				<span class="small-12 flex vertical-align">
					C
				</span>
			</li>
		</ul>
		<div class="small-12 taxBreakdown border borderRadius8" v-if="future_item">
			<div class="small-12 columns widgetTitle flex vertical-align">
				<h2 class="small-12 flex vertical-align">
					Tax Assessment Breakdown
				</h2>
			</div>
			<div class="small-12 stats">
				<ul class="small-12 flex">
					<li class="small-12 columns flex vertical-align">
						<div class="small-12 large-6">
							<p>Improvements Assessment:</p>
						</div>
						<div class="small-12 large-4 flex vertical-align">
							<i class="material-icons outlined">attach_money</i>
							<span>1,594,700</span>
						</div>
					</li>
					<li class="small-12 columns flex vertical-align">
						<div class="small-12 large-6">
							<p>Land Assessment:</p>
						</div>
						<div class="small-12 large-6 flex vertical-align">
							<i class="material-icons outlined">attach_money</i>
							<span>581,800</span>
						</div>
					</li>
					<li class="small-12 columns border-top flex vertical-align totalAssessment">
						<div class="small-12 large-6">
							<p>Total Assessment:</p>
						</div>
						<div class="small-12 large-6 flex vertical-align">
							<i class="material-icons outlined">attach_money</i>
							<span>2,176,500</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="small-12 emptyResults" v-else>
			<picture class="small-12 flex justify-center vertical-align">
				<img width="120" :src="empty_image" alt="Taxes Document">
			</picture>
			<h6 class="small-12 text-center">
				Tax record not found
			</h6>
			<p class="small-12 text-center">
				A tax assessment for this property has not been added yet.
			</p>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyTaxes',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false,
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Ftaxes-calculator.svg?alt=media&token=57702806-4d0e-4e38-900d-6cbc7f397bf0'

		}),

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		 /*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>